import { render, staticRenderFns } from "./view-fba-shipment-modal.vue?vue&type=template&id=25533ef3&scoped=true&"
import script from "./view-fba-shipment-modal.vue?vue&type=script&lang=js&"
export * from "./view-fba-shipment-modal.vue?vue&type=script&lang=js&"
import style0 from "./view-fba-shipment-modal.vue?vue&type=style&index=0&id=25533ef3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25533ef3",
  null
  
)

export default component.exports